"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25",
    width: "25",
    height: "25"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#E5332A",
    d: "M14.6,19.8H6.1c-0.3,0-0.5-0.2-0.5-0.5V5.7c0-0.3,0.2-0.5,0.5-0.5h8.4c0.3,0,0.5,0.2,0.5,0.5v13.6 C15.1,19.6,14.8,19.8,14.6,19.8z M6.6,18.8h7.4V6.2H6.6V18.8z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#E5332A",
    d: "M12.6,16.6h-1.3c-0.3,0-0.5-0.2-0.5-0.5v-2.6c0-0.3,0.2-0.5,0.5-0.5h1.3c0.3,0,0.5,0.2,0.5,0.5v2.6 C13.1,16.3,12.9,16.6,12.6,16.6z M11.8,15.6h0.3V14h-0.3V15.6z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#E5332A",
    d: "M19.1,16.6c-0.1,0-0.2,0-0.3-0.1c-0.1-0.1-0.2-0.3-0.2-0.4v-1.9c0-0.3,0.2-0.5,0.5-0.5h1.3 c0.3,0,0.5,0.2,0.5,0.5v1.3c0,0.2-0.1,0.4-0.3,0.4l-1.3,0.6C19.3,16.6,19.2,16.6,19.1,16.6z M20.4,15.4L20.4,15.4L20.4,15.4z M19.6,14.6v0.6l0.3-0.1v-0.5H19.6z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#E5332A",
    d: "M19.1,14.6c-0.3,0-0.5-0.2-0.5-0.5v-1c0-0.5,0.7-1.4,2.1-2.6c0.2-0.2,0.5-0.2,0.7,0 c0.2,0.2,0.2,0.5,0,0.7c-0.9,0.8-1.7,1.7-1.8,1.9l0,0.9C19.6,14.4,19.4,14.6,19.1,14.6z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#E5332A",
    d: "M17.8,19.8c-1,0-1.8-0.8-1.8-1.8V9.3c0-0.3-0.2-0.5-0.5-0.5h-1c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h1 c0.8,0,1.5,0.7,1.5,1.5V18c0,0.4,0.4,0.8,0.8,0.8s0.8-0.4,0.8-0.8v-1.9c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5V18 C19.6,19,18.8,19.8,17.8,19.8z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#E5332A",
    d: "M14.6,11.4H6.1c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h8.4c0.3,0,0.5,0.2,0.5,0.5S14.8,11.4,14.6,11.4z"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "7.4",
    y: "7",
    fill: "#E5332A",
    width: "5.8",
    height: "2.6"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#E5332A",
    d: "M12.6,17.9h-1.3c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h1.3c0.3,0,0.5,0.2,0.5,0.5S12.9,17.9,12.6,17.9z "
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.5,25C5.6,25,0,19.4,0,12.5S5.6,0,12.5,0S25,5.6,25,12.5S19.4,25,12.5,25z M12.5,1C6.2,1,1,6.2,1,12.5S6.2,24,12.5,24 S24,18.8,24,12.5S18.8,1,12.5,1z"
  }));
};

exports["default"] = _default;